/*
 * textarea光标操作工具文件
 * 实现获取光标位置 设置光标位置 在指定位置插入内容
 */
 const NormalRange = {
    text : "",
    start : 0, 
    end : 0
}
const Range = {};
Range.getCursor = function(ele){
    let rangeData = {...NormalRange};
    if(ele.setSelectionRange) { // W3C
        rangeData.start= ele.selectionStart;
        rangeData.end = ele.selectionEnd;
        rangeData.text = (rangeData.start != rangeData.end) ? ele.value.substring(rangeData.start, rangeData.end) : "";
    }
    else if(document.selection){ // IE
        let i;
        let oS = document.selection.createRange();
        let oR = document.body.createTextRange();
        oR.moveToElementText(ele);
        rangeData.text = oS.text;
        rangeData.bookmark = oS.getBookmark();
        // object.moveStart(sUnit [, iCount])
        // Return Value: Integer that returns the number of units moved.
        for (i = 0; oR.compareEndPoints('StartToStart', oS) < 0 && oS.moveStart("character", -1) !== 0;i ++){
            // Why? You can alert(ele.value.length)
            if(ele.value.charAt(i) == '\n') {
                i++;
            }
        }
        rangeData.start = i;
        rangeData.end = rangeData.text.length + rangeData.start;
    }
    return rangeData;
};

Range.setCursor = function(ele, rangeData){
    let oR;
    if(!rangeData) {
        rangeData = {...NormalRange};
    }
    ele.focus();
    if(ele.setSelectionRange){ // W3C
        ele.setSelectionRange(rangeData.start, rangeData.end);
    }
    else if(ele.createTextRange){ // IE
        oR = ele.createTextRange();
        // Fixbug : ues moveToBookmark()
        // In IE, if cursor position at the end of _txt, the set function don't work
        if(ele.value.length === rangeData.start){
            //alert('hello')
            oR.collapse(false);
            oR.select();
        }
        else{
            oR.moveToBookmark(rangeData.bookmark);
            oR.select();
        }
    }
};

Range.addText =  function({ele, rangeData, text, callback}){
    rangeData = rangeData || {...NormalRange};
    let oValue;
    let nValue;
    let oR;
    let sR;
    let nStart;
    let nEnd
    let st;
    Range.setCursor(ele, rangeData);
    if (ele.setSelectionRange){ // W3C
        oValue = ele.value;
        nValue = oValue.substring(0, rangeData.start) + text + oValue.substring(rangeData.end);
        nStart = nEnd = rangeData.start + text.length;
        st = ele.scrollTop;
        ele.value = nValue;
        // After textarea.values = nValue, scrollTop value to 0
        if(ele.scrollTop != st) {
            ele.scrollTop = st;
        }
        ele.setSelectionRange(nStart, nEnd);
    }
    else if(ele.createTextRange){ // IE
        sR = document.selection.createRange();
        sR.text = text;
        sR.setEndPoint('StartToEnd', sR);
        sR.select();
    }
    callback();
    //_v._$dispatchEvent(ele, 'keyup');
};
export default Range;



// WEBPACK FOOTER //
// ./client/component/at/cursor.js